import reactComponentLoader from 'scripts/react-component-loader'

import { WhatsApp } from './WhatsApp'

reactComponentLoader(WhatsApp, '[data-whatsapp]')
